module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEwSURBVGhD7dZNLgRRFIbhMrEOZiIGbIA1MGEbvQI7EBGxGmZiKkKwhjYTkYgI7xmc5EZ93Sj3npQ4b/JM+tb9qaSqu7ssy7Isy7LsR72PwCMGpxaMdo9edlfqYuepsWin6HUDdbHz1Fi0ffQ6hLrYeWos2gZ6reENaoLx1FikO8zsBGqS8dRYpB3MbBH2gqiJnhqLco4FzM1u4hifHyev/CzSFMv4dqs4wDXKHw61eGsv2EKV1AYtPWAT1VKbtHKBJVRNbVSb/VXYxpcv7JDUhr/xBPtuP4P9wq4j+9epx6Q0+tShS6NPHbo0+tShS6NpBUe4xTPUYeexOTbX1rC1QpvA/p+ogw1ha9maIe1BHaKGXTTvCmrzGi7RvFeozWuwtZunNq4py7Isy7I/Utd9AP2VhKIkr7eVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-metal/dark/48.png
// module id = 2245
// module chunks = 2